<script setup>
import IconHawkTableTwo from '~icons/hawk/table-two';
import { useCommonImports } from '~/common/composables/common-imports.composable.js';
import { useNaavixHelpers } from '~/naavix/composables/naavix-helpers.composable';

const props = defineProps({
  functionCallsMap: {
    type: Array,
    default: () => [],
  },
  functionResponses: {
    type: Array,
    default: () => [],
  },
  isThisMessageStreaming: {
    type: Boolean,
    default: false,
  },
});

const { $t } = useCommonImports();

const { openTableModal } = useNaavixHelpers();

const state = reactive({
  show_all: false,
});

const ITEMS_LIMIT = 3;

const icon_render_map = {
  table: {
    icon: IconHawkTableTwo,
    onClick: (data) => {
      openTableModal(data);
    },
  },
};

const filtered_function_responses = computed(() => {
  const filtered = props.functionResponses.filter((function_response) => {
    return icon_render_map[function_response.response.artifact_type];
  });

  return state.show_all ? filtered : filtered.slice(0, ITEMS_LIMIT);
});

const total_items = computed(() => {
  return props.functionResponses.filter((function_response) => {
    return icon_render_map[function_response.response.artifact_type];
  }).length;
});

const has_more_items = computed(() => {
  return total_items.value > ITEMS_LIMIT;
});

function toggleShowAll() {
  state.show_all = !state.show_all;
}
</script>

<template>
  <template v-if="filtered_function_responses.length && !props.isThisMessageStreaming">
    <div class="text-sm font-normal text-gray-500 mt-3 mb-1">
      {{ $t('References') }}
    </div>
    <div
      v-for="function_response in filtered_function_responses"
      :key="function_response.id"
      class="flex items-center gap-2 text-sm font-normal text-gray-900 cursor-pointer hover:underline"
      @click="icon_render_map[function_response.response.artifact_type].onClick(function_response.response)"
    >
      <component
        :is="icon_render_map[function_response.response.artifact_type].icon"
        class="w-3 h-3 text-gray-600"
      />
      {{ props.functionCallsMap[function_response.id].title }}
    </div>
    <button
      v-if="has_more_items"
      class="text-sm font-medium text-gray-800 hover:text-gray-900 mt-1 ml-5 cursor-pointer flex items-center gap-1"
      @click="toggleShowAll"
    >
      {{ state.show_all ? $t('Show less') : $t('See all') }}
      <IconHawkArrowRight v-if="!state.show_all" class="text-gray-600" />
    </button>
  </template>
</template>
